export default "__VITE_ASSET__CjQrZj8Q__"